import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import { connectSearchBox } from 'react-instantsearch/connectors';
import { Input, InputWrapper, IconWrapper } from './style';
import SearchIcon from '../../images/searchIcon';

const Icon = () => (
  <IconWrapper>
    <SearchIcon width={25} height={40} />
  </IconWrapper>
);

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
    };
  }
  debouncedRefinement = debounce(value => this.props.refine(value), 500);

  refine = () => {
    const { inputValue } = this.state;
    this.debouncedRefinement(inputValue);
  };

  handleChange = value => {
    this.setState(
      {
        inputValue: value,
      },
      () => this.refine()
    );
  };

  render() {
    const { placeholder } = this.props;

    const { inputValue } = this.state;
    return (
      <InputWrapper {...this.props}>
        <Icon />
        <Input
          placeholder={placeholder}
          value={inputValue}
          onChange={e => this.handleChange(e.target.value)}
        />
      </InputWrapper>
    );
  }
}

export default connectSearchBox(SearchBox);



// WEBPACK FOOTER //
// ./src/components/searchbox/index.js